<template>
  <div class="flex flex-col">
    <h2>Usuarios</h2>

    <router-link
      v-if="hasPermission('edit_admins')"
      :to="{ name: 'adminsCreateForm' }"
      class="primary-button mx-0 mt-2"
      >Crear Usuario</router-link
    >

    <custom-search
      class="mt-6 w-[500px]"
      placeholder="Buscar por Nombre"
      v-model="searchText"
      @confirm="search"
      @clear="search"
    />

    <div class="card mt-6">
      <table class="table-auto text-sm mt-2">
        <thead class="text-left">
          <tr class="bg-primary-100">
            <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">ID</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Nombre</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Correo</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Rol</th>
            <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="admin in admins" :key="admin.id" class="table-row">
            <td class="table-cell">
              {{ admin.id }}
            </td>
            <td class="table-cell">{{ admin.name }} {{ admin.last_name }}</td>
            <td class="table-cell">
              {{ admin.user.email }}
            </td>
            <td class="table-cell">
              {{
                admin.user.role
                  ? admin.user.role.name
                  : admin.is_super
                  ? "Super Admin"
                  : ""
              }}
            </td>

            <td class="table-cell">
              <div class="flex">
                <router-link
                  :to="{
                    name: 'adminsDetail',
                    params: { id: admin.id },
                  }"
                  class="secondary-button"
                  >Detalle</router-link
                >
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="loading" class="flex w-full h-full items-center">
        <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
      </div>
    </div>

    <pagination
      :current-page="currentPage"
      :total-pages="totalPages"
      @page-change="onPageChange"
    />
  </div>
</template>

<script>
import api from "@/api";
import Pagination from "@/components/ui/Pagination.vue";
export default {
  name: "Admins",

  components: {
    Pagination,
  },

  data() {
    return {
      admins: null,
      loading: false,
      searchText: "",
      currentPage: 1,
      totalPages: 0,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "admins");

    this.loadAdmins();
  },

  methods: {
    async loadAdmins() {
      this.loading = true;

      try {
        const response = await api.admins.getAllWithQueryParams([
          {
            name: "page",
            value: this.currentPage,
          },
          {
            name: "search",
            value: this.searchText,
          },
        ]);
        this.admins = response.data;
        this.currentPage = response.current_page;
        this.totalPages = response.last_page;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    search() {
      this.currentPage = 1;
      this.loadAdmins();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.loadAdmins();
    },
  },
};
</script>